/**
 * Captcha Component - Invisible ALTCHA PoW trigger (sl-wwta.3.2)
 *
 * This component triggers the ALTCHA PoW challenge solving in the background.
 * It renders nothing — the challenge is solved invisibly by CaptchaService.
 * Once solved, CaptchaService.verifyToken$ emits the solution payload.
 */
import { CaptchaService } from '@affine/core/modules/cloud';
import { useService } from '@toeverything/infra';
import { useEffect } from 'react';

export const Captcha = () => {
  const captchaService = useService(CaptchaService);

  useEffect(() => {
    if (
      !captchaService.verifyToken$.value &&
      !captchaService.isLoading$.value
    ) {
      void captchaService.revalidate();
    }
  }, [captchaService]);

  // ALTCHA is invisible — no UI needed
  return null;
};
